export default __webpack_public_path__ + "static/media/storageUnit1-beforeB.da8ea7cb.jpg";